module.exports = __webpack_public_path__ + "static/dueftlogo-5d76fa2d979866791222361b4a0e48e7.png";